import { render, staticRenderFns } from "./SymbolsChipsListItem.vue?vue&type=template&id=7328925c&scoped=true"
import script from "./SymbolsChipsListItem.vue?vue&type=script&lang=js"
export * from "./SymbolsChipsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328925c",
  null
  
)

export default component.exports